<div class="container">

  <div class="my-2 row align-items-center d-flex justify-content-center gap-1">
    <div class="col-6 date-range-selector ms-1 d-flex justify-content-center gap-2 align-items-center">
      @if(monthYearOnly){
        <div>
          <form [formGroup]="metricRange" class="date-form">
            <app-lt-daterange-month-year #ltDateRange
              formControlName="dateRange"
              [startLabel]="'Start'"
              format="MMM yyyy"
              [endLabel]="'End'">
            </app-lt-daterange-month-year>
          </form>
        </div>
        <div>
          <button matButton="elevated" (click)="submitDateRange()" >Apply</button>
        </div>
      }
      @else {
        <div class="row">
          <div class="col">
            <mat-form-field appearance="fill" class="example-form-field">
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                <input matStartDate formControlName="start" placeholder="Start date">
                <input matEndDate formControlName="end" placeholder="End date">
              </mat-date-range-input>
              <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>

              @if (range.controls.start.hasError('matStartDateInvalid')) {
                <mat-error>Invalid start date</mat-error>
              }
              @if (range.controls.end.hasError('matEndDateInvalid')) {
                <mat-error>Invalid end date</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col my-auto">
            <button matButton="elevated" (click)="submitDateRange($event)">Apply</button>
          </div>
        </div>
      }
    </div>

    <div class="col-5 date-range-buttons d-flex justify-content-center gap-2">
      <button matButton="elevated" (click)="submitDefaultRange('yearToDate')">Year to Date</button>
      <button matButton="elevated" (click)="submitDefaultRange('thisYear')">This Year</button>
      <button matButton="elevated" (click)="submitDefaultRange('past3Months')">Last 3 Months</button>
      @if (showThisMonthButton) {
        <button matButton="elevated" (click)="submitDefaultRange('lastMonth')">Last Month</button>
      }
    </div>

  </div>

  @if (hasDateRangeSelected) {
    <div class="my-2 row align-items-center">
      <h5 class="title-center my-2">
        @if (dateStringPrefix) {
          <span>{{dateStringPrefix}} | </span>
        } Selected Range: {{currentStartDate | date:'MM/dd/y'}} - {{currentEndDate | date:'MM/dd/y'}}
      </h5>
    </div>
  }

</div>
